import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "BaseItemDialog__section flex-1"
}
const _hoisted_2 = { class: "BaseItemDialog__section-header bg-white q-mb-12" }
const _hoisted_3 = { class: "fs-15px fw-600 text-cool-gray-100 block q-mb-sm" }
const _hoisted_4 = { class: "BaseItemDialog__section-body" }
const _hoisted_5 = { class: "q-px-sm" }
const _hoisted_6 = { class: "fs-15px text-cool-gray-100" }

import translate from 'src/common/helpers/language/translate'
import { IItemView } from 'src/common/interfaces'
import globalTranslateObject from 'src/translate/global.translate'

interface IProps {
  item: IItemView
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseItemDialogAllergens' },
  __name: 'BaseItemDialogAllergens',
  props: {
    item: {}
  },
  setup(__props: any) {




const { t: globalT } = translate(globalTranslateObject)

return (_ctx: any,_cache: any) => {
  const _component_k_divider = _resolveComponent("k-divider")!

  return (__props.item.allergen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(globalT)('allergens')), 1 /* TEXT */),
          _createVNode(_component_k_divider, { size: "md" })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(__props.item.allergen), 1 /* TEXT */)
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})